import React, { useState, useEffect, useRef } from "react";
import { withRouter } from "react-router-dom";
// import TopJson from "./top";
import Image from "../atom/image";
import HeaderMain from "./mainjson";
import './header.css';

const Header = (props) => {

    const openMobile = () => {
        document.querySelector("body").classList.toggle("wsactive");
    };

    const handleLogout = () => {
        props.logout();
    }


    return (
        <React.Fragment>

            <div className="headerfull">
                <div className="desktoplogo header-alignment">
                    <div className="row desktoplogopanel ri_login_header">
                        <div className="col-auto moheader-logo-sec">
                            <a
                                id="wsnavtoggle"
                                onClick={openMobile}
                                className="wsanimated-arrow"
                            >
                                <span></span>
                            </a>
                            <a className="logo-a">
                                <Image
                                    image="prelogin-header/Logo.png"
                                    class="d-none d-sm-inline-block"
                                />
                                <Image
                                    image="prelogin-header/logo-mo-asset.png"
                                    class="d-inline-block d-sm-none"
                                />
                            </a>
                        </div>
                    </div>
                    {
                        props.showButton ? <div className="logoutDiv">
                            {/* <div className="nav-profile-img">
                                <Image image="nav/profile-icon.png" class="mobileProfile" alt="image" />
                            </div> */}
                            <div className="nav-profile-text">
                                <p className="mb-1 text-black">{props.name}</p>
                            </div>
                            {/* </a> */}
                            <button className="logout_btn" onClick={handleLogout}>
                                Logout
                            </button>
                        </div> : null
                    }

                </div>
            </div>

        </React.Fragment>
    );
};

export default withRouter(Header);
